export enum PageRoutes {
	Home = '/',
	MCOHome = '/mco',
	GOAAHome = '/goaa',
	ParkingAvailability = '/parking-availability',
	SecurityWaitTimes = '/security',
	Flights = '/flights',
	FlightsArrival = '/flights/arrival',
	FlightsDeparture = '/flights/departure',
	FlightDetail = '/flight',
	ShopDineRelax = '/shops-restaurants-services',
	DirectionsTraffic = '/directions-and-traffic',
	CareersHome = '/careers',
	Jobs = '/careers/jobs',
	Map = '/terminal-maps/map',
	Search = '/search',
	GroundTransportation = '/terminal-information/ground-transportation',
	Privacy = '/privacy-policy',
	Airlines = '/airlines',
	RentalCars = '/rental-cars',
	Media = '/media',
	MediaIndustryNews = '/media/industry-news',
	MediaPressReleases = '/media/press-releases',
	MediaPressReleasesItem = '/media/press-releases/item',
	MediaCenter = '/media/media-center',
	FAQ = '/faq',
}

export enum BusinessPageRoutes {
	Home = '/airport-business',
	BusinessNews = '/airport-business/news',
	SunshineMeetings = '/airport-business/sunshine-meetings/documents',
	SunshineMeetingsCalendars = '/airport-business/sunshine-meetings/calendars',
	Contracts = '/airport-business/contracts',
	Policies = '/airport-business/policies',
}

export enum ORLPageRoutes {
	Home = '/orlando-executive-airport',
}

export enum MCOCaresPageRoutes {
	Home = '/mcocares',
}
